import jigCategoryOptionsJson from './JigCategoryOptions.json';
import { TenantHelpers } from '@/utils/tenant-helpers';
import { defaultTenantsPagination } from '@/store/modules/Constants'

import { JigSummaryStats, ReportJigSummaryStats, Tenant, TenantToken } from './types';

export default {
  uid: 0,
  forceRerenderKey: 0,
  jigDailyActivityData: [] as JigSummaryStats[],
  jigDailyViewsData: [] as ReportJigSummaryStats[],
  tenantActivity: {},
  jigsCreatedByUserType: {},
  lastUpdateTime: {},
  drawer: null,
  color: 'warning',
  // deprecated, use myTenant
  myPreviousTenantIndex: TenantHelpers.InvalidTenantIndex,
  // deprecated, use myTenant
  myTenantIndex: TenantHelpers.InvalidTenantIndex,
  myTenant: TenantHelpers.GetDefaultTenant(),
  myTenantToken: TenantHelpers.GetDefaultTenantToken(),
  myTenantTokens: [] as TenantToken[],
  myTenants: [] as Tenant[],
  myTenantTotalJigCount: -1,
  myJigs: [],
  teamJigs: [],
  jigMetadata: {
    ProjectName: '',
    FormatVersion: 0,
  },
  jigDetailPermissions: null,
  copyJigResult: null,
  saveJigResult: null,
  saveJigVisibilityResult: null,
  loading: true,
  loadingModal: false,
  isStatisticsLoading: false,
  modelsLibrary: [],
  libraryEntry: {
    DisplayName: '',
    Tags: [],
    Categories: [],
  },
  apiError: '',
  jigCategoryOptions: jigCategoryOptionsJson,
  libraryCategories: {
    Categories: [],
    CategoryOrder: [],
  },
  defaultLibraryCategory: {
    DisplayName: 'New Category',
    CategoryOrder: -1,
    StateId: 0,
    StateName: 'Under Construction',
  },
  libraryCategoryStates: {
    States: [],
  },
  changeJigOwnerResult: {
    message: '',
    status: '',
  },
  uploadThumbnailResult: {
    status: '',
    thumbnailURL: '',
  },
  queuedStatusResult: {
    queueId: '', // UUID
    processingType: '', // 'undefined', 'astc_library_entry_thumbnail', 'obj_assimp' etc
    status: '', // 'queued', 'in-progress', 'done', 'failed'
    originalFile: '',
    files: [],
    params: [], // map of string:string
    errorMessage: '',
    wasRead: false,
    dateCreated: '', // golang time.Time
  },
  tenants: [],
  totalTenantsQty: -1,
  totalTenantsPages: -1,
  tenantUsers: [],
  tenantUserCount: -1,
  tenantUserRoles: [],
  tenantUserRoleDisplayNames: [],
  creditCardSetupIntentClientSecret: '',
  customerWithPaymentMethod: {},
  tenantSetupJob: {},
  sendEmailVerificationResult: {},
  // This is a trimmed down example of a subscription from Stripe
  subscription: {
    "stripeSubscription": {
      "id": "sub_HBQjK9ylcGKmDm",
      "object": "subscription",
      "billing_cycle_anchor": 1588120445,
      "cancel_at_period_end": false,
      "canceled_at": 1588203315,
      "collection_method": "charge_automatically",
      "created": 1588120445,
      "current_period_end": 1590712445,
      "current_period_start": 1588120445,
      "customer": "cus_HBQaFPI1kIZP1d",
      "default_payment_method": null,
      "default_source": null,
      "ended_at": 1588203315,
      "latest_invoice": {
        "id": "in_1Gd3sHIw3NbX0D1sti8M7yZI",
        "hosted_invoice_url": "https://pay.stripe.com/invoice/acct_19knSxIw3NbX0D1s/invst_HBQjf215NW6iPKYkiu3Cn6nDZBXJYHh",
        "invoice_pdf": "https://pay.stripe.com/invoice/acct_19knSxIw3NbX0D1s/invst_HBQjf215NW6iPKYkiu3Cn6nDZBXJYHh/pdf",
        "paid": false,
        "payment_intent": {
          "id": "pi_1Gd3sHIw3NbX0D1sqlIROrPg",
          "status": "canceled",
        },
        "period_end": 1588120445,
        "period_start": 1588120445,
        "post_payment_credit_notes_amount": 0,
        "pre_payment_credit_notes_amount": 0,
        "starting_balance": 0,
        "status": "void",
        "status_transitions": {
          "finalized_at": 1588120445,
          "voided_at": 1588203315,
        },
        "subscription": "sub_HBQjK9ylcGKmDm",
        "subscription_proration_date": 0,
        "subtotal": 2000,
        "total_tax_amounts": [],
        "total": 2000,
        "webhooks_delivered_at": 1588120445,
      },
      "metadata": {
        "Environment": "dev",
        "TenantId": "1490",
      },
      "status": "incomplete_expired",
    },
  },
  checkoutUrl: '',
  customerPortalUrl: '',
  latestDesktopVersion: {
    Version: '',
    SupportStart: '',
  },
  // Counter for shareable link store change trigger as $store object change can't trigger a watch event
  shareableLinkTrigger: 0,
  embedParamsConfig: {},

  // The selected row count to show in data tables
  libraryItemsPerPage: 10,
  myJigsItemsPerPage: 10,
  teamJigsItemsPerPage: 10,
  tenantsItemsPerPage: defaultTenantsPagination.limit,
  tenantUsersItemsPerPage: -1, // all
  allTenantsCurrentPage: 1,
  dynaconfConfig: {
    pricing: {
      sets: {},
    },
  },
};
